import { useEffect } from 'react';
import { toErrorMessage } from '@/modules/auth/utils';
import type { Unit } from '@/modules/company';
import { type PhoneLine, useConnectLine } from '../api';
import { situacaoDaUnidade } from './unit-status';
import { WhatsappSummary } from './whatsapp-summary';

interface ConnectStepProps {
  linha: PhoneLine;
  unit: Unit;
}

export function ConnectStep({ linha, unit }: ConnectStepProps) {
  const conectar = useConnectLine();

  const jaLigada = unit.whatsappFrom === linha.phoneNumber;
  const { isIdle, mutate: registrarRemetente } = conectar;

  useEffect(() => {
    if (jaLigada || !isIdle) return;

    registrarRemetente({ id: linha.id, unitId: unit.id });
  }, [jaLigada, isIdle, registrarRemetente, linha.id, unit.id]);

  if (situacaoDaUnidade(unit, linha).setup === 'conectada') {
    return <WhatsappSummary unit={unit} linha={linha} />;
  }

  return (
    <div className="space-y-4">
      <WhatsappSummary unit={unit} linha={linha} pending={conectar.isPending} />

      {conectar.error ? (
        <p className="text-sm text-destructive">{toErrorMessage(conectar.error)}</p>
      ) : (
        <p className="text-sm text-muted-foreground">
          A liberacao e feita pela Meta e costuma levar algumas horas. Voce pode fechar esta tela:
          assim que o numero for liberado, a unidade passa a enviar mensagens.
        </p>
      )}
    </div>
  );
}
